import React from 'react';
import { useContactForm } from './hooks/useContactForm';
import FullNameInput from './components/FullNameInput';
import PhoneInput from './components/PhoneInput';
import EmailInput from './components/EmailInput';
import TopicSelect from './components/TopicSelect';
import TermsCheckbox from './components/TermsCheckbox';
import SubmitButton from './components/SubmitButton';
import SuccessMessage from './components/SuccessMessage';
import './ContactForm.css';

const ContactForm: React.FC = () => {
    const {
        form,
        errors,
        isLoading,
        isSuccess,
        submitError,
        handleChange,
        handleBlur,
        handleSubmit,
    } = useContactForm();


    return (
        <div className="cf-card" dir="rtl">
            <h2 className="cf-title">לרכישה ומידע נוסף</h2>

            <FullNameInput
                value={form.fullName}
                error={errors.fullName}
                onChange={(v) => handleChange('fullName', v)}
                onBlur={() => handleBlur('fullName')}
            />
            <PhoneInput
                value={form.phone}
                error={errors.phone}
                onChange={(v) => handleChange('phone', v)}
                onBlur={() => handleBlur('phone')}
            />
            <EmailInput
                value={form.email}
                error={errors.email}
                onChange={(v) => handleChange('email', v)}
                onBlur={() => handleBlur('email')}
            />
            <TopicSelect
                value={form.topic}
                error={errors.topic}
                onChange={(v) => handleChange('topic', v)}
                onBlur={() => handleBlur('topic')}
            />
            <TermsCheckbox
                checked={form.termsAccepted}
                error={errors.termsAccepted}
                onChange={(v) => handleChange('termsAccepted', v)}
                onBlur={() => handleBlur('termsAccepted')}
            />



            {/* Honeypot — invisible to users, bots auto-fill this */}
            <input
                type="text"
                name="website"
                value={form.website}
                onChange={(e) => handleChange('website', e.target.value)}
                aria-hidden="true"
                tabIndex={-1}
                autoComplete="off"
                style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', height: 0, width: 0 }}
            />

            <SubmitButton
                isLoading={isLoading}
                isDisabled={false}
                onClick={handleSubmit}
            />

            {submitError && (
                <div className="cf-error-banner">
                    <p className="cf-error-message">{submitError}</p>
                </div>
            )}

            {isSuccess && <SuccessMessage />}
        </div>
    );
};

export default ContactForm;
